module.exports = __webpack_public_path__ + "img/spinner.96760950.png";